/** Human-facing product name. Keep this the single place the app's name
 * is spelled out, so the login page / page titles / emails never drift. */
export const APP_NAME = "XOP Reseller";

/** Production origin this app is served at (see docs/superpowers/specs
 * for the reseller-identity design this app builds on). */
export const PRODUCTION_ORIGIN = "https://reseller.xopnetworks.com";

/** Prefix every BFF route lives under. */
export const API_PREFIX = "/api";
